<custom-label *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
<p-checkbox
  [ngClass]="{'text-red-500': labelBottomRed, 'pt-3': !placeholder }"
  [label]="label"
  [binary]="true"
  inputId="binary"
  [ngModel]="value.value"
  (onChange)="onUserToggle()"
/>


